export default __webpack_public_path__ + "static/media/accumulator.9f91e39a.svg";